export default {
	// Copy

	// Feature Flags
	feature_summary: false,
	feature_documents: false,
	feature_test_data: false,
	feature_assistant_management: false,
	feature_childSupport: false,
	feature_pension_calculator: false,
	feature_holiday_schedule: false,
	feature_support_calculator: false,
	// Combined Parenting Schedule (weekly rotation + holidays + year calendar).
	// When on, it replaces the Parenting Time Planner and Holiday Schedule tabs.
	// Enable per-environment in the Firebase Remote Config console, not here.
	feature_parenting_schedule: false,
	feature_lawyer_founding_plan: true,
	feature_revision_history: false,

	// Access
	staging: false,
};
